export default __webpack_public_path__ + "static/media/dashboard-report.caf9fe2e.svg";